import React, { Component } from "react";

import CountryTranslator from "../Country/CountryTranslator";
import CustomSelect from "../../elements/CustomSelect/CustomSelect";
import { FormattedMessage } from "react-intl";
import { error } from "util";
import fetch from "node-fetch";

//
// lookup siren opendatasoft api to get company data
//
class CompanySelectSiren extends Component {
  constructor(props) {
    super();
    console.log("CompanySelectSiren constructor");
    //   super(props)
    //   // lookup country code
    //   console.log('countries', countries)
    //   const c = countries.getNames('fr')
    //   console.log('countries', countries)
    //
    //   this.state = {
    //     countries: c
    //   }
  }

  // lookup country code given french full country name
  // findCountry = (value) => {
  //   return _.findKey(this.state.countries, function (o) {
  //     console.log(_.upperCase(o), value)
  //     return _.includes(_.upperCase(o), value)
  //   })
  //
  // }

  // componentDidMount(){
  //   if(this.props.autoFocus){
  //     this.fetchAutocompleteData(this.props.value)
  //   }
  // }

  convertOpenData = value => {
    // console.log("converting ", value, " ", typeof value);
    if (typeof value === "string") {
      return {
        name: value // covert new item addition
      };
    } else {
      if (!value) return {};

      // normalize the data
      let address = "";
      address += value.l2_normalisee ? value.l2_normalisee + "\n" : "";
      address += value.l3_normalisee ? value.l3_normalisee + "\n" : "";
      address += value.l4_normalisee ? value.l4_normalisee + "\n" : "";
      address += value.l5_normalisee ? value.l5_normalisee + "\n" : "";
      address += value.l6_normalisee ? value.l6_normalisee + "\n" : "";

      const countryCode = value.l7_normalisee
        ? CountryTranslator.findFRCountryCodeByName(value.l7_normalisee)
        : "FR";
      // console.log('lookupcountry', )

      return {
        // covers api fetch
        name: value.l1_normalisee,
        siren: value.siren,
        siret: value.siret,
        forme: value.libnj ? value.libnj : "",
        address: address,
        country: value.l7_normalisee ? value.l7_normalisee : "France",
        countryCode: countryCode,
        ape: value.apet700,
        tvaIntra: "",
        capitalSocial: ""
        //      tvaIntra: value.fields.tvaintra
        //      capitalSocial: value.fields.
      };
    }
  };

  fetchAutocompleteData(input) {
    console.log("fetchAutocompleteData", input);
    if (input) {
      return fetch(
        `https://data.opendatasoft.com/api/records/1.0/search/?dataset=sirene%40public&q="${input}"&rows=300`
      )
        .then(response => response.json())
        .then(json => {
          console.log(json);
          let records = [
            {
              label: input,
              value: input
            }
          ];

          if (json.records.length > 0) {
            json.records.map(record => {
              return records.push({
                label: `${record.fields.l1_normalisee} - ${
                  record.fields.l6_normalisee
                }`,
                value: `${record.fields.l1_normalisee}`,
                data: record.fields //`${record.fields.l1_normalisee}` //record.fields
              });
            });

            return { options: records };
          } else {
            return {
              options: records
            };
          }
        })
        .catch(err => {
          console.log("failed to fetch", error);
          return -1;
        });
    } else return [];
  }

  // builds an object containing at least a 'name 'field'
  // @value is either a simple string, or an option item object (label,value)

  onSelected = value => {
    console.log("CompanySelectSiren onSelected", value);
    const t = value;
    if (value && value.value) {
      // conpound object
      value = this.convertOpenData(value.data);

      // add missing name
      if (!value.name) value.name = t;
      this.props.onSelected({
        company: value
      });
    } else {
      // string object
      this.props.onSelected({
        company: { name: t }
      });
    }
  };

  componentDidUpdate(props, state) {
    console.log("componentDidUpdate", props);
  }

  render() {
    console.log("CompanySelectSiren render", this.props);

    return (
      <CustomSelect
        autoFocus={this.props.autoFocus}
        inputValue={{ label: this.props.value, value: this.props.value }}
        displaysOptionsAt={3}
        // label="company"
        creatable={false}
        multi={false}
        onSelected={this.onSelected}
        convertOpenData={this.convertOpenData}
        fetchData={this.fetchAutocompleteData}
        placeholder={<FormattedMessage id="ids_companyName" />}
      />
    );
  }
}

export default CompanySelectSiren;
